import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { useBenefisUIContext } from "../BenefisUIContext";
import { BenefisDeleteDialogHeader } from "./BenefisDeleteDialogHeader";
import { BenefisDeleteForm } from "./BenefisDeleteForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/benefis/benefisAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";

export const BenefisDeleteDialog = ({ id, show, onHide }) => {
  // Benefis UI Context
  const benefisUIContext = useBenefisUIContext();
  const benefisUIProps = useMemo(() => {
    return {
      queryParams: benefisUIContext.queryParams,
      setQueryParams: benefisUIContext.setQueryParams,
    };
  }, [benefisUIContext]);

  // Benefis Redux state
  const dispatch = useDispatch();
  const { actionsLoading, benefisForEdit, error } = useSelector(
    (state) => ({
      actionsLoading: state.benefis.actionsLoading,
      benefisForEdit: state.benefis.benefisForEdit,
      error: state.benefis.error,
    }),
    shallowEqual
  );

  if (error) {
    toast.error(error, toastOption);
  }
  useEffect(() => {
    // server call for getting Benefis by id
    dispatch(actions.fetchBenefis(id));
  }, [id, dispatch]);

  const deleteBenefis = () => {
    dispatch(actions.deleteBenefis(id)).then((response) => {
      toast.success(response.message, toastOption);
      dispatch(actions.fetchBenefiss(benefisUIProps.queryParams));
      onHide();
    });
  };

  return (
    <Modal show={show} onHide={onHide} aria-labelledby="modal-sizes-title-lg">
      <BenefisDeleteDialogHeader id={id} />
      <BenefisDeleteForm
        deleteBenefis={deleteBenefis}
        actionsLoading={actionsLoading}
        benefis={benefisForEdit}
        onHide={onHide}
      />
    </Modal>
  );
};
